import React from 'react'
import { LoginForm } from 'components/index'
import styles from './Login.module.scss'
import cx from 'classnames'

function Login() {
  return (
    <div className={styles.wrapper}>
      <div className={cx(styles.inner, styles.login)}>
        <div className={styles.login__inner}>
          <LoginForm />
        </div>
      </div>
  
    </div>
  )
}

export default Login
